import { components } from 'react-select';
import { withClassName } from '../helpers';
export var GenericSelectControlPlaceholder = withClassName(components.Placeholder, 'placeholder');